import { getAuth } from "firebase/auth";
import axios from "axios";

import { logoutUser } from "./ApiHelpers";
import { toast } from "react-toastify";

const defaultHeaders = {
  "Content-Type": "application/json",
  "timezone-offset": new Date().getTimezoneOffset()
};

if (!import.meta.env.VITE_API_URL) {
  console.warn("Problem with VITE_API_URL", import.meta.env.VITE_API_URL);
}

const appClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 40000,
  headers: defaultHeaders
});

appClient.interceptors.request.use(async function (config) {
  try {
    const auth = getAuth();
    // Force refresh if we suspect issues, but generally false (default) uses cache which is efficient.
    // However, to be 100% sure we don't send stale tokens near expiry, the SDK handles this.
    // If the token is expired it auto-refreshes.
    const authToken = await auth.currentUser?.getIdToken();
    if (authToken) config.headers.token = authToken;
    return config;
  } catch (e) {
    return config;
  }
});

appClient.interceptors.response.use(
  async function (response) {
    return response;
  },
  function (error) {
    if ([401].includes(error.response?.status)) {
      toast.error(error.response?.data?.message);
      logoutUser();
    }
    return Promise.reject(error);
  }
);

export { appClient };
